import { CapoPlugin } from "/codebuild/output/src1971087859/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];